import { __assign, __generator } from "tslib";
import { call, put, delay, select } from 'redux-saga/effects';
import { reloadStashStream } from '../actions';
import { getCurrentFolderId } from '../selectors';
import { uploadFile } from '../../redux/uploads/actions';
export function uploadFileHandler(payload) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(uploadFile(__assign(__assign({}, payload), { onSuccess: function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, delay(1000)];
                                case 1:
                                    _a.sent(); // wait arbitrary 1s for stash to update
                                    return [4 /*yield*/, put(reloadStashStream())];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    } })))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function uploadFileSaga(_a) {
    var folderId, _b;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = payload.folderId;
                if (_b) return [3 /*break*/, 2];
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 1:
                _b = (_c.sent());
                _c.label = 2;
            case 2:
                folderId = _b;
                return [4 /*yield*/, call(uploadFileHandler, __assign(__assign({}, payload), { folderId: folderId }))];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default uploadFileSaga;
//# sourceMappingURL=uploadFile.js.map